<template>
  <b-container class="h-100 ems-page">
    <b-row class="pt-5 pb-5">
      <b-col><img src="@/App/assets/logo.png" height="100px" /></b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6" md="6" sm="12">
        <b-alert id="sso__error" :show="!!errorMessage" variant="danger" class="sso__error">
          {{ errorMessage }}
        </b-alert>

        <div v-if="isHandlingToken" id="sso__loading" class="text-center">
          <b-spinner variant="danger" />
          <p class="mt-3">Signing you in...</p>
        </div>

        <b-button v-if="errorMessage" id="sso__back-button" variant="danger" block @click="onBackClicked()">
          Return to login
        </b-button>
      </b-col>
    </b-row>
    <ContactInfo />
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ContactInfo from "@/App/components/ContactInfo.vue";

function firstQueryValue(value) {
  const first = Array.isArray(value) ? value[0] : value;

  return typeof first === "string" ? first : "";
}

export default {
  name: "SsoHandleToken",
  components: { ContactInfo },
  computed: {
    ...mapState("Sso", ["isHandlingToken", "errorMessage"]),
  },
  mounted() {
    const token = firstQueryValue(this.$route.query.token);
    const signOutUrl = firstQueryValue(this.$route.query.signOutUrl);

    window.history.replaceState({}, document.title, window.location.pathname);

    this.handleSsoToken({ token, signOutUrl });
  },
  methods: {
    ...mapActions("Sso", ["handleSsoToken"]),
    onBackClicked() {
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.sso__error {
  white-space: pre-line;
}
</style>
